import { Box, styled } from "@mui/material";

import theme, { palette } from "~frontend/theme";

export const AccentBox = styled(Box)({
  backgroundColor: palette.white,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
});
